import {ClientEvent} from '@udemy/event-tracking';

import {SubscriberEngagementRecapCallToActionType} from 'src/generated/graphql';

import {SubscriberEngagementRecapStatsType} from './types';

const CTA_TYPE_TO_EVENT_MAP = {
    [SubscriberEngagementRecapCallToActionType.ContinueCourse]: 'continue_course',
    [SubscriberEngagementRecapCallToActionType.RecommendedCourse]: 'recommended_course',
    [SubscriberEngagementRecapCallToActionType.RenewSubscription]: 'renew_subscription',
    [SubscriberEngagementRecapCallToActionType.TryAssessments]: 'try_assessment',
} as const;

const METRIC_TO_EVENT_MAP = {
    [SubscriberEngagementRecapStatsType.CertificationCount]: 'certification_count',
    [SubscriberEngagementRecapStatsType.CoursesCompletedCount]: 'courses_completed_count',
    [SubscriberEngagementRecapStatsType.CoursesEnrolledCount]: 'courses_enrolled_count',
    [SubscriberEngagementRecapStatsType.LearningDaysCount]: 'learning_days_count',
    [SubscriberEngagementRecapStatsType.LongestWeeklyStreak]: 'longest_weekly_streak',
    [SubscriberEngagementRecapStatsType.MinutesWatched]: 'minutes_watched',
    [SubscriberEngagementRecapStatsType.TopicsExplored]: 'topics_explored',
} as const;

type CtaEventValue = (typeof CTA_TYPE_TO_EVENT_MAP)[SubscriberEngagementRecapCallToActionType];
type MetricEventType = (typeof METRIC_TO_EVENT_MAP)[SubscriberEngagementRecapStatsType];

export class SubscriberEngagementRecapPresentedEvent extends ClientEvent {
    ctaType: CtaEventValue;
    uiRegion: string;

    constructor({ctaType}: {ctaType: SubscriberEngagementRecapCallToActionType}) {
        super('SubscriberEngagementRecapPresented');
        this.ctaType = CTA_TYPE_TO_EVENT_MAP[ctaType];
        this.uiRegion = 'recap_banner';
    }
}

export class SubscriberEngagementRecapCTAClickEvent extends ClientEvent {
    ctaType: CtaEventValue;
    uiRegion: string;

    constructor({ctaType}: {ctaType: SubscriberEngagementRecapCallToActionType}) {
        super('SubscriberEngagementRecapCTAClicked');
        this.ctaType = CTA_TYPE_TO_EVENT_MAP[ctaType];
        this.uiRegion = 'recap_banner';
    }
}

export class SubscriberEngagementRecapMetricPresentedEvent extends ClientEvent {
    metric: MetricEventType;
    uiRegion: string;

    constructor({metric}: {metric: SubscriberEngagementRecapStatsType}) {
        super('SubscriberEngagementRecapMetricPresented');
        this.metric = METRIC_TO_EVENT_MAP[metric];
        this.uiRegion = 'recap_banner';
    }
}
